export default "__VITE_ASSET__CSdeH8Oh__"